import { IntegrationConnectionStore } from './store'

export const integrationConnectionStore =
  IntegrationConnectionStore.new()
export {
  deleteIntegrationConnection,
  type DeleteIntegrationResponseData,
} from './store'
